const galleryImages = [
  {
    src: "https://storage.readdy-site.link/project_files/35b57ced-d75b-4532-9a59-9b08ce476502/ac59a1bd-9824-4a86-8b73-691e8751b069_compressed_GH-2.webp",
    alt: "Checking inbound cosmetics products and quantities at GH warehouse",
    step: "01 Receiving",
    label: "Check inbound products, quantities and outer-carton condition.",
  },
  {
    src: "https://storage.readdy-site.link/project_files/35b57ced-d75b-4532-9a59-9b08ce476502/73245f87-031a-4666-a21e-476f625d53f1_compressed_515590e5-b853-4590-9853-cf1d6b731d2f.webp",
    alt: "Consolidating cosmetics products from multiple brands into one shipment",
    step: "02 Consolidation",
    label: "Combine products from multiple brands into one organized shipment.",
  },
  {
    src: "https://storage.readdy-site.link/project_files/35b57ced-d75b-4532-9a59-9b08ce476502/00b52033-dc4f-4828-b224-9668112f6dbc_compressed_-.webp",
    alt: "Coordinating cartons, palletizing, labeling and export-ready protection",
    step: "03 Packing",
    label: "Coordinate cartons, palletizing, labeling and export-ready protection.",
  },
  {
    src: "https://storage.readdy-site.link/project_files/35b57ced-d75b-4532-9a59-9b08ce476502/65aa3aad-5233-4d5f-9ddb-d0099c495d16_compressed_19.webp",
    alt: "Selecting sea or air routing for international cosmetics freight",
    step: "04 Shipping",
    label: "Select sea or air routing based on destination, order volume, cost and delivery schedule.",
  },
];

export default function ExportGallery() {
  return (
    <section className="w-full px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-accent-500" />
            <span className="font-label text-[11px] tracking-[0.22em] uppercase text-accent-700">
              Operations
            </span>
            <span className="w-8 h-px bg-accent-500" />
          </div>
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl lg:text-6xl leading-[1.05] font-light">
            Export-Ready Operations
            <br />
            <span className="italic">for Beauty Shipments</span>
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-foreground-700 text-base md:text-lg leading-relaxed font-light">
            From product receiving to pallet loading, GH Corporation coordinates the practical details required before international freight departure.
          </p>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {galleryImages.map((img) => (
            <div
              key={img.step}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={img.src}
                  alt={img.alt}
                  title={`GH export operations — ${img.step}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="p-5">
                <span className="font-label text-[10px] tracking-[0.22em] uppercase text-accent-700">
                  {img.step}
                </span>
                <p className="mt-2 text-foreground-700 text-[14px] leading-relaxed font-light">
                  {img.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-foreground-500 text-[12px] font-light">
          Representative export-operation images
        </p>
      </div>
    </section>
  );
}